















































import { Component, Prop, Watch, Config, BasePage } from "@/common";
import { TwTable } from "@/components";

@Component({})
export default class TwFileManager extends BasePage {
  @Prop({})
  private loadAction: string;
  @Prop({})
  private uploadAction: string;
  @Prop({})
  private deleteAction: string;
  @Prop({})
  private exportAction: string;

  @Prop({})
  private data: string;

  @Prop({})
  private beforeUpload: Function;

  @Prop({})
  private beforeDelete: Function;

  @Prop({})
  private beforeExport: Function;

  private get params(): object {
    return { code: this.data };
  }

  private get filesTable(): TwTable {
    return this.$refs["filesTable"] as TwTable;
  }

  private accept: string =
    ".jif,.jpge,.jpg,.png,.bmp,.pdf,.xls,.xlsx,.doc,.docx,.ppt,.pptx";

  private format: Array<string> = [
    "jif",
    "jpge",
    "jpg",
    "png",
    "bmp",
    "pdf",
    "xls",
    "xlsx",
    "doc",
    "docx",
    "ppt",
    "pptx"
  ];

  private get Host(): string {
    return this.uploadAction;
  }

  private progress: number = 0;

  private preView: boolean = false;

  private preViewSrc: string = "";

  private InterceptBeforeUpload(file): boolean {
    let result = true;
    if (this.beforeUpload) {
      result = this.beforeUpload(file);
    }
    return result;
  }

  private onProgress(event, file, fileList) {
    this.progress = event.percent;
  }

  private onSuccess(response, file, fileList) {
    if (response !== "") {
      this.error(`${file.name}:上传异常[${response}]`);
    } else {
      this.success(`文件${file.name}上传成功`);
      this.loadFiles();
    }
  }

  private onError(error, file) {
    this.error(`${file.name}:上传失败[${error}]`);
  }

  private onFormatError(file, fileList) {
    this.error(
      `${file.name}:格式错误,只允许上传[${this.format.join(",")}]格式`
    );
  }

  private clearFiles() {
    (this.$refs["TwinkleTUpload"] as any).clearFiles();
  }

  private success(message: string) {
    this.$message.success(message);
  }

  private error(message: string) {
    this.$message.error(message);
  }
  private filesHead = [
    {
      label: "文件名称",
      prop: "cFileName",
      align: "center",
      width: 200,
      attrs: {
        type: "string"
      }
    },
    {
      label: "文件格式",
      prop: "cFormat",
      align: "center",
      width: 100,
      attrs: {
        type: "string"
      }
    },
    {
      label: "文件大小",
      prop: "nSize",
      align: "center",
      width: 150,
      attrs: {
        type: "string"
      },
      formatter: this.renderFileSize
    },
    {
      label: "上传人",
      prop: "username",
      align: "center",
      width: 100,
      attrs: {
        type: "string"
      }
    },
    {
      label: "上传时间",
      prop: "dUploadDate",
      align: "center",
      width: 150,
      attrs: {
        type: "date"
      },
      formatter: this.renderDateTime
    }
  ];

  renderFileSize(row, col, value, index) {
    let result = "";
    if (value) {
      value = parseInt(value, 10);
      if (value > 1024 * 1024 * 1024) {
        result = `${(value / (1024 * 1024 * 1024)).toFixed(1)}G`;
      } else if (value > 1024 * 1024) {
        result = `${(value / (1024 * 1024)).toFixed(1)}M`;
      } else if (value > 1024) {
        result = `${(value / 1024).toFixed(1)}KB`;
      } else {
        result = `${value}byte`;
      }
    } else {
      result = "0";
    }
    return result;
  }

  renderDateTime(row, col, value, index) {
    return this.$moment(new Date(value)).format("YYYY-MM-DD HH:mm:ss");
  }

  private exportFiles() {
    if (this.beforeExport) {
      if (!this.beforeExport()) {
        return;
      }
    }
    const selections = this.getSelections();
    if (selections) {
      const Ids = selections.map(item => {
        return item.ID;
      });
      this.$http
        .post(this.exportAction, { Ids })
        .then(res => {})
        .catch(err => {
          this.$message.warning(err);
        });
    }
  }

  private deleteFiles() {
    if (this.beforeDelete) {
      if (!this.beforeDelete()) {
        return;
      }
    }
    const selections = this.getSelections();

    if (selections) {
      const Ids = selections.map(item => {
        return item.ID;
      });

      this.$http
        .post(this.deleteAction, { Ids })
        .then(res => {
          if (res.data.status === 0) {
            this.loadFiles();
          } else {
            this.$message.warning(`删除失败:${res.data.msg}`);
          }
        })
        .catch(err => {
          this.$message.warning(err);
        });
    }
  }

  private dblClick(data) {
    let url = "";
    if (data.cFilePath.substr(0, 4).toLocaleLowerCase() === "http") {
      url = decodeURIComponent(data.cFilePath);
    } else {
      url = decodeURIComponent(`${Config.baseUrl}${data.cFilePath}`);
    }

    //.jif,.jpge,.jpg,.png,.bmp,.pdf

    if (
      url.toLocaleLowerCase().endsWith(".jif") ||
      url.toLocaleLowerCase().endsWith(".jpge") ||
      url.toLocaleLowerCase().endsWith(".jpg") ||
      url.toLocaleLowerCase().endsWith(".png") ||
      url.toLocaleLowerCase().endsWith(".bmp") ||
      url.toLocaleLowerCase().endsWith(".pdf")
    ) {
      // this.preView = true;
      // this.preViewSrc = url;
      const target = "_blank";
      const features = "toolbar=no,menubar=no,location=no,status=no";
      window.open(url, target, features);
    } else {
      window.location.href = url;
    }
  }

  private getSelections() {
    const selections = this.filesTable.getSelections();
    if (selections.length === 0) {
      this.$message.warning("请先选择要操作的文件");
      return null;
    } else {
      return selections;
    }
  }

  loadFiles() {
    this.filesTable.load(this.params);
  }

  mounted() {
    //this.loadFiles();
  }

  @Watch("data")
  doLoad() {
    this.loadFiles();
  }
}
